import { CourseType } from '../../../types'
import { getCourseLessons } from './getCourseLessons'
import { getCourseCompletedLessons } from './getCourseCompletedLessons'

export const getCourseCompletedPercentage = (course?: CourseType, checkUserRecord?: boolean) => {
  if (!course?.modules) {
    return 0
  }

  const allLessons = getCourseLessons(course)
  const completedLessons = getCourseCompletedLessons(course, checkUserRecord)

  const quotient = completedLessons.length / allLessons.length
  return quotient * 100
}
